import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import antdEn from 'antd/lib/locale-provider/en_US';
import defaultI18n from './i18n';
import { LocaleInnerConfigProvider } from './Context';
export var defaultMeta = {
  en: {
    antd: antdEn,
    countryFlag: 'gb',
    label: 'English'
  }
};
export var LocaleConfigProvider = function LocaleConfigProvider(_ref) {
  var i18n = _ref.i18n,
      props = _objectWithoutPropertiesLoose(_ref, ["i18n"]);

  return React.createElement(I18nextProvider, {
    i18n: i18n
  }, React.createElement(LocaleInnerConfigProvider, props));
};
LocaleConfigProvider.defaultProps = {
  i18n: defaultI18n,
  fallbackLanguage: 'en',
  languageMeta: defaultMeta
};